/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */

import Environments from "../Environments";
import LogoutService from "./api/LogoutService";
import { router } from "./hook/useRouterNavigation";
import { showErrorMessage } from "./hook/useDialogStateHelper";
import { logout as logoutContext } from "./authorization/Authorization";
import { getLmWindow, setLmWindow } from "./hook/useWindowStateHelper";

const logoutService = new LogoutService();

export const logout = () => {
    if (!Environments.MOCK) {
        const fetch = async () => {
            await logoutService.logout(
                () => {
                    // LM画面が開いていたら閉じる
                    const sub = getLmWindow();
                    if (sub) {
                        sub.close();
                        setLmWindow(null);
                    }

                    // ログアウト処理
                    logoutContext();
                    router("/");
                },
                (error: any) => {
                    console.error(error);
                    showErrorMessage({ message: "ログアウトに失敗しました。\n管理者に連絡してください。", error });
                }
            );
        };
        void fetch();
    } else {
        router("/");
    }
};
